import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'

/** گزینه‌های مرتب‌سازیِ لیستِ قراردادهای ناظر/مشاور */
const OPTIONS = [
  { value: 'name', label: 'پیمانکار (سپس تاریخ نزولی)' },
  { value: 'sub', label: 'پیمانکاران مشترک در بالا' },
  { value: 'date', label: 'تاریخ قرارداد (نزولی)' },
]

export default function SortSelect({ value = 'name', onChange }) {
  return (
    <FormControl variant="outlined" size="small" style={{ minWidth: 240 }}>
      <InputLabel>مرتب‌سازی</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        label="مرتب‌سازی"
      >
        {OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
